import React from 'react';
import AppRoutes from './routes';
import { AuthProvider } from './features/auth';

const App: React.FC = () => (
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
);

export default App;
